import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { useAction } from '@agro-club/frontend-shared'
import CompanyActions from '../../../../../modules/domain/company/duck'
import CompanySelectors from '../../../../../modules/domain/company/selectors'
import { CompanyListRequestFilter } from '../../../../../modules/domain/company/types'
import AntDPartnerTypeSelect from '../../../PartnerTypeSelect/AntDPartnerTypeSelect'

type CompanyPartnerTypeFilterSelectProps = {
  excludeCompanyIds: string[]
}

const CompanyPartnerTypeFilterSelect: React.FC<CompanyPartnerTypeFilterSelectProps> = ({ excludeCompanyIds }) => {
  const { t } = useTranslation('labels')
  const filter = useSelector(CompanySelectors.listByExcludedIdsFilter)
  const filterUpdated = useAction(CompanyActions.listByExcludedIdsFilterUpdated)

  const handleFilterChange = useCallback(
    (newFilterValue: Partial<CompanyListRequestFilter>) => {
      filterUpdated({ exclude_companies: excludeCompanyIds, filters: { ...filter, ...newFilterValue } })
    },
    [filterUpdated, excludeCompanyIds, filter],
  )

  const onChange = (values: string[]) => {
    handleFilterChange({ partner_types_ids: values.length > 0 ? values : undefined })
  }

  return <AntDPartnerTypeSelect placeholder={t('partnerType')} onChange={onChange} />
}

export default CompanyPartnerTypeFilterSelect
